<template>
  <form>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.myProfile')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a v-if="userId !== loggedUserId" class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="cancelUser">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p>
          <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15">
      <div :class="isNew ? 'col-md-6 ' : 'col-lg-6 col-md-12'">
        <div class="card">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div v-if="!isNew" style="display: none;">
                  id: {{model.id}}
                </div>
                <div class="form-group" v-if="isNew && !fromDispatchSettings && !fromKdsSettings && !fromDispatcherSettings">
                  <label>{{$t('settingUsers.role')}}</label>
                  <select name="role" class="form-control"
                                v-validate="modelValidate.role"
                                v-model="model.role"
                                :disabled="!isNew"
                                @change="getDriverCode(model.role)">
                    <option value="" selected disabled>{{$t('general.select')}}</option>
                    <option v-for="(role, key) in roles"
                                :value="key"
                                :label="role"
                                :key="key">
                    </option>
                  </select>
                  <small class="text-danger" v-show="role.invalid">
                    {{ getError('role') }}
                  </small>
                </div>
                <div class="form-group" v-if="isNew && fromDispatchSettings">
                  <label>{{$t('settingUsers.role')}}</label>
                  <select name="role" class="form-control"
                                v-validate="modelValidate.role"
                                v-model="model.role"
                                :disabled="!isNew"
                                @change="onDispatchRoleChange(model.role)">
                    <option value="" selected disabled>{{$t('general.select')}}</option>
                    <option value="DRIVER">
                      {{ roles.DRIVER || $t('settingUsers.DRIVER') }}
                    </option>
                    <option value="DISPATCHER">
                      {{ roles.DISPATCHER || $t('settingUsers.DISPATCHER') }}
                    </option>
                  </select>
                  <small class="text-danger" v-show="role.invalid">
                    {{ getError('role') }}
                  </small>
                </div>
                <div class="form-group" v-if="isNew && fromDispatcherSettings">
                  <label>{{$t('settingUsers.role')}}</label>
                  <select name="role" class="form-control"
                                v-validate="modelValidate.role"
                                v-model="model.role"
                                :disabled="!isNew">
                    <option value="" selected disabled>{{$t('general.select')}}</option>
                    <option value="DISPATCHER" selected>
                      {{ roles.DISPATCHER || $t('settingUsers.DISPATCHER') }}
                    </option>
                  </select>
                  <small class="text-danger" v-show="role.invalid">
                    {{ getError('role') }}
                  </small>
                </div>
                <div class="form-group" v-if="isNew && fromKdsSettings">
                  <label>{{$t('settingUsers.role')}}</label>
                  <select name="role" class="form-control"
                                v-validate="modelValidate.role"
                                v-model="model.role"
                                :disabled="!isNew"
                                @change="getDriverCode(model.role)">
                    <option value="" selected disabled>{{$t('general.select')}}</option>
                    <option value="KDS_OPERATOR" selected>
                      {{ roles.KDS_OPERATOR }}
                    </option>
                  </select>
                  <small class="text-danger" v-show="role.invalid">
                    {{ getError('role') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role && (model.role == 'USER' || model.role == 'DRIVER' || model.role == 'DISPATCHER' || model.role == 'LOCATION_ADMIN' || model.role == 'LOCATION_STORE_ADMIN' || model.role == 'OPERATOR'|| model.role == 'USER_CUSTOM')">
                  <label>{{$t('settingUsers.locations')}}</label>
                  <v-select v-model="model.locations"
                            multiple
                            :options="locations"
                            value="id"
                            label="name">
                  </v-select>
                  <small class="text-muted">
                    {{$t('settingUsers.locations_helptext')}}
                  </small>
                </div>
                <div class="form-group" v-if="model.role && (model.role == 'DRIVER')">
                  <label>{{$t('settingUsers.zones')}}</label>
                  <v-select v-model="model.delivery_ranges"
                            multiple
                            :options="filteredData"
                            value="id"
                            label="name">
                  </v-select>
                </div>
                <div class="form-group" :class="{'has-error': hasFieldError('firstname')}">
                  <label>{{$t('settingUsers.fn')}}</label>
                  <input type="text"
                          name="firstname"
                          :placeholder="$t('settingUsers.fn')"
                          v-validate="dispatcherMode ? '' : modelValidate.firstname"
                          v-model="model.firstname"
                          class="form-control"
                          :class="{ error: hasFieldError('firstname') }"
                          :aria-invalid="hasFieldError('firstname') ? 'true' : 'false'"
                          @blur="onDispatcherFieldChange('firstname')"
                          @input="onDispatcherFieldChange('firstname')">
                  <small class="text-danger" v-if="hasFieldError('firstname')">
                    {{ $t('validations.requiredField') }}
                  </small>
                </div>
                <div class="form-group" :class="{'has-error': hasFieldError('lastname')}">
                  <label>{{$t('settingUsers.ln')}}</label>
                  <input type="text"
                          name="lastname"
                          :placeholder="$t('settingUsers.ln')"
                          v-validate="dispatcherMode ? '' : modelValidate.lastname"
                          v-model="model.lastname"
                          class="form-control"
                          :class="{ error: hasFieldError('lastname') }"
                          :aria-invalid="hasFieldError('lastname') ? 'true' : 'false'"
                          @blur="onDispatcherFieldChange('lastname')"
                          @input="onDispatcherFieldChange('lastname')">
                  <small class="text-danger" v-if="hasFieldError('lastname')">
                    {{ $t('validations.requiredField') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role != 'DISPATCHER'">
                  <div class="form-group">
                    <label>Fiscal Printer</label>
                    <select
                      name="location"
                      class="form-control"
                      v-model="model.fiscal_printer_id"
                    >
                      <option :value="null" >{{$t('general.none')}}</option>
                      <option
                        v-for="(el) in fiscalPrinter"
                        :value="el.id"
                        :label="el.series"
                        :key="el.id">
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group" v-if="model.role != 'DISPATCHER'">
                  <label>Server Ip:port</label>
                  <input type="text"
                          name="server_ip_port"
                          data-vv-as="server_ip_port"
                          placeholder="192.168.100.100:6999"
                          v-model="model.server_ip_port"
                          class="form-control">
                  <small class="text" >
                    You need a proxy server
                  </small>
                </div>
                <div class="form-group" v-if="model.role == 'DRIVER'">
                  <label>{{$t('settingUsers.phone')}}</label>
                  <input type="text"
                          name="phone"
                          :placeholder="$t('settingUsers.phone')"
                          v-validate="modelValidate.phone"
                          v-model="model.phone"
                          class="form-control">
                  <small class="text-danger" v-if="errors.has('phone')">
                    {{ getError('phone') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role != 'DRIVER' && model.role != 'DISPATCHER'" :class="{'has-error': hasFieldError('email')}">
                  <label>{{$t('settingUsers.email')}}</label>
                  <input type="text"
                          name="email"
                          :placeholder="$t('settingUsers.email')"
                          v-validate="modelValidate.email"
                          v-model="model.email"
                          class="form-control"
                          :class="{ error: hasFieldError('email') }"
                          :aria-invalid="hasFieldError('email') ? 'true' : 'false'">
                  <small class="text-danger" v-if="hasFieldError('email')">
                    {{ $t('validations.requiredField') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role == 'DISPATCHER'" :class="{'has-error': hasFieldError('login_code')}">
                  <label>{{$t('settingTable.login_code')}}</label>
                  <input type="text"
                          name="login_code"
                          maxlength="4"
                          inputmode="numeric"
                          :placeholder="$t('settingTable.login_code')"
                          v-model="model.login_code"
                          class="form-control"
                          :class="{ error: hasFieldError('login_code') }"
                          :aria-invalid="hasFieldError('login_code') ? 'true' : 'false'"
                          @blur="onDispatcherFieldChange('login_code')"
                          @input="onDispatcherFieldChange('login_code')">
                  <small class="text-danger" v-if="hasFieldError('login_code')">
                    {{ $t('validations.requiredField') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role == 'DISPATCHER'">
                  <label>{{$t('settingLocationGroups.active')}}</label>
                  <p-switch v-model="model.active" type="success"></p-switch>
                </div>
                <template v-if="model.role == 'DISPATCHER'">
                  <div>
                    <label>{{$t('settingTable.is_manager')}}</label>
                    <p-switch v-model="is_manager" type="success"></p-switch>
                  </div>
                  <div class="isManagerBox">
                    <div class="managerBox" v-if="is_manager">
                      <div class="form-group">
                        <label>{{$t('settingTable.pos_allow_access_reports')}}</label>
                        <p-switch v-model="model.pos_allow_access_reports" type="success"></p-switch>
                      </div>
                      <div class="form-group">
                        <label>{{$t('settingTable.pos_allow_reports')}}</label>
                        <p-switch v-model="model.pos_allow_reports" type="success"></p-switch>
                      </div>
                      <div class="form-group">
                        <label>{{$t('settingTable.pos_allow_approvals')}}</label>
                        <p-switch v-model="model.pos_allow_approvals" type="success"></p-switch>
                      </div>
                      <div class="form-group">
                        <label>{{$t('settingTable.pos_allow_discount')}}</label>
                        <p-switch v-model="model.pos_allow_discount" type="success"></p-switch>
                      </div>
                      <div class="form-group">
                        <label>{{$t('settingTable.pos_allow_refund')}}</label>
                        <p-switch v-model="model.pos_allow_refund" type="success"></p-switch>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="form-group" v-if="model.role == 'DRIVER'">
                  <label>{{$t('settingUsers.username')}}</label>
                  <input type="text"
                          name="email"
                          :placeholder="$t('settingUsers.username')"
                          v-validate="modelValidate.email"
                          v-model="model.email"
                          class="form-control"
                          disabled>
                  <small class="text-danger" v-if="errors.has('email')">
                    {{ getError('email') }}
                  </small>
                </div>
                <div v-if="isNew && model.role != 'DISPATCHER'" class="form-group">
                  <label class="control-label">{{$t('settingUsers.password')}}</label>
                  <input type="password"
                          ref="password"
                          name="password"
                          :placeholder="$t('settingUsers.password')"
                          v-validate="modelValidate.password"
                          v-model="model.password"
                          class="form-control">
                    <small class="text-danger" v-if="errors.has('password')">
                    {{ getError('password') }}
                  </small>
                </div>
                <div v-if="isNew && model.role != 'DISPATCHER'" class="form-group">
                  <label class="control-label">{{$t('settingUsers.confPass')}}</label>
                  <input type="password"
                          name="password_confirmation"
                          :placeholder="$t('settingUsers.confPass')"
                          v-validate="modelValidate.password_confirmation"
                          v-model="model.password_confirmation"
                          class="form-control">
                  <small class="text-danger" v-if="errors.has('password_confirmation')">
                    {{ getError('password_confirmation') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role != 'OWNER' && !isNew">
                  <label>{{$t('settingUsers.role')}}</label>
                  <select name="role" class="form-control"
                                v-validate="modelValidate.role"
                                v-model="model.role"
                                :disabled="!isNew">
                    <option value="" selected disabled>{{$t('general.select')}}</option>
                    <option v-for="(role, key) in roles"
                                :value="key"
                                :label="role"
                                :key="key">
                    </option>
                  </select>
                  <small class="text-danger" v-show="role.invalid">
                    {{ getError('role') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role != 'DISPATCHER'">
                  <label>{{$t('settingUsers.lang')}}</label>
                  <select class=" form-control" placeholder=" - Select Language - " v-model="model.language" v-validate="modelValidate.language">
                    <option v-for="(label, key) in languages"
                                :value="key"
                                :label="label"
                                :key="key">{{label}}</option>
                  </select>
                  <small>{{$t('settingUsers.langMsg')}}</small>
                  <small class="text-danger" v-if="errors.has('language')">
                    {{ getError('language') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role != 'DISPATCHER'">
                  <label>{{$t('settingUsers.avatar')}}</label>
                  <el-upload
                    action=""
                    ref="upload"
                    :limit="2"
                    :file-list="model.imagelist"
                    list-type="picture-card"
                    accept=" .jpg, .jpeg, .png"
                    :on-change="handleImgChnage"
                    :on-exceed="handleExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false">
                    <img src="/static/img/icons/icon-plus-primary.png">
                    <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                  </el-upload>
                </div>
              </div>
          <!--         <div v-if="model.role == 'user'" class="col-md-12">
                <div class="form-group">
                  <label>Permissions</label>
                    <p-checkbox name="permissions"
                                v-for="perm in permissions"
                                v-model="model.permissions[perm.permission_id]"
                                :value="perm.permission_id"
                                :label="perm.label"
                                :key="perm.permission_id"
                                >{{perm.label}} {{ model.permissions[perm.permission_id] }}</p-checkbox>

                </div>
              </div> -->
            </div>
          </div>


        </div>
      </div>
      <div v-if="!isNew" class="col-lg-6 col-md-12">
        <div class="card">
          <div :class="(loadingReset ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <form class="">
          <!--  <div class="card-header">

            </div> -->
            <div class="row card-content">
              <div class="col-md-12" >
                <p>
                  {{$t('settingUsers.resetPass')}}
                </p>
                <hr class="sm">
              </div>
              <div class="col-md-12 form-group">
                <label class="control-label">{{$t('settingUsers.pass')}}</label>
                <input type="password"
                            ref="password"
                            name="password"
                            :placeholder="$t('settingUsers.pass')"
                            v-model="model.password"
                            class="form-control"
                            :aria-invalid="errors.has('password_2') ? true : false">
                <small class="text-danger" v-if="errors.has('password_2')">
                  {{ getError('password_2') }}
                </small>
              </div>
              <div class="col-md-12 form-group">
                <label class="control-label">{{$t('settingUsers.confPass')}}</label>
                <input type="password"
                            :placeholder="$t('settingUsers.confPass')"
                            v-model="model.password_confirmation"
                            class="form-control"
                            :aria-invalid="errors.has('password_confirm_2') ? true : false">
                <small class="text-danger" v-if="errors.has('password_confirm_2')">
                  {{ getError('password_confirm_2') }}
                </small>
              </div>
            </div>
            <div class="row card-footer">
              <div class="col-md-12 form-group">
                <label></label>
                <button type="submit" class="btn reset" @click.prevent="validateReset">
                  {{$t('general.reset')}}
                </button>
              </div>
            </div>
          </form>
        </div> <!-- end card -->
      </div> <!--  end col-md-6  -->


      <div v-if="model.role == 'DRIVER' && !isNew" class="col-lg-6 col-md-12">
        <div class="card">
          <div :class="(loadingReset ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="form-group" style="display: none; margin: 30px 20px; margin-bottom: 10px;">
            <label>{{ $t('settingUsers.active') }}</label>
            <p-switch
              v-model="model.driver_schedule_active"
              type="success"
            ></p-switch>
          </div>
          <div class="form-group" style="margin: 30px 20px; margin-bottom: 10px;">
            <label>
              {{ $t('settingUsers.scheduleStatus') }}
              <strong :class="model.driver_schedule_active ? 'text-success' : 'text-danger'">
                {{ model.driver_schedule_active ? $t('settingUsers.scheduleActive') : $t('settingUsers.scheduleInactive') }}
              </strong>
            </label>
          </div>
          <form>
          <!--  <div class="card-header">

            </div> -->
            <div class="row card-content">
              <div class="col-md-12" >
                <h6 class="card-title">
                  {{$t('settingUsers.program')}}
                </h6>
                <hr class="sm">
              </div>
              <div class="row" v-for="(day, dayIdx) in model.driver_schedule" style="display: flex; align-items: flex-start; padding: 20px;">
                <div class="col-md-12">
                  <span>{{available_days[dayIdx]}}</span>
                  <div>
                    <template v-for="(interval, intervalKey) in day">
                      <div class="interval">
                        <div class="int">
                          From
                          <el-time-select
                                          placeholder="Select time"
                                          :value="interval.from"
                                          v-model="interval.from"
                                          v-validate="modelValidate.available_days"
                                          :picker-options="pickerOptions">
                          </el-time-select>
                          To
                          <el-time-select
                                          placeholder="Select time"
                                          :value="interval.to"
                                          v-model="interval.to"
                                          v-validate="modelValidate.available_days"
                                          :picker-options="pickerOptions">
                          </el-time-select>
                          <button class="btn btn-simple btn-icon " @click.prevent="deleteIntervals(dayIdx, intervalKey)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="col-md-2">
                  <button class="btn btn-info btn-icon "
                          @click.prevent="addMoreIntervals(dayIdx)"
                          :title="$t('general.add')  + ' moreIntervals'" >
                    <i class="ti-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div> <!-- end card -->
      </div> <!--  end col-md-6  -->

      <div v-if="userRole != 'USER_CUSTOM' && (model.role == 'LOCATION_ADMIN' || model.role == 'LOCATION_STORE_ADMIN' || model.role == 'USER_CUSTOM') && !isNew" class="col-lg-6 col-md-12">
        <div class="card">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <form>
            <div class="row card-content">
              <div class="col-md-12" >
                <h6 class="card-title">
                  {{$t('settingUsers.permissions')}}
                </h6>
                <hr class="sm">
              </div>
              <div class="row" style="display: flex; align-items: flex-start; padding: 20px;">
                <div class="col-md-12" v-if="model.permissions_map">


                  <template v-if="model.role == 'USER_CUSTOM'">
                    <p>{{ $t('settingUsers.permissionsGeneral') }}</p>
                    <div class="row" v-for="(value, key) in model.permissions_map" :key="key">
                      <div
                        class="col-md-12"
                        v-if="key.startsWith('general_') && key !== 'general_can_access_price_lists'"
                      >
                        <p-checkbox
                          v-model="model.permissions_map[key]"
                          @input="onGeneralPermissionChange(key, $event)"
                        >
                          {{ $t('permission.' + key) }}
                        </p-checkbox>
                        <div
                          v-if="key === 'general_can_access_catalog'"
                          class="col-md-12"
                          style="padding-left: 28px; margin-top: 4px;"
                        >
                          <p-checkbox
                            v-model="model.permissions_map.general_can_access_price_lists"
                            :disabled="!model.permissions_map.general_can_access_catalog"
                          >
                            {{ $t('permission.general_can_access_price_lists') }}
                          </p-checkbox>
                        </div>
                      </div>
                    </div>
                    <br>
                  </template>
                  <p>{{ $t('settingUsers.permissionsGestiune') }}</p>
                  <div class="row" v-for="(value, key) in model.permissions_map" :key="key">
                    <div class="col-md-12" v-if="allowedPermissions.includes(key)">
                      <p-checkbox v-model="model.permissions_map[key]">
                        {{ $t('permission.' + key) }}
                      </p-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div> <!-- end card -->
      </div> <!--  end col-md-6  -->

    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      PSwitch,
      // GeneralTopBar,
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      userId: null,
      callback: {
        required: false
      },
      route: {
        type: Object,
        default: () => ({})
      }
    },
    watch: {
      userId (value) {
        this.id = value
      },
      is_manager () {
        this.onChangeManager()
      }
    },
    computed: {
      ...mapFields(['name', 'last_name', 'email', 'job', 'role']),
      filteredData () {
        if (!this.model || !Array.isArray(this.model.locations)) {
          return []
        }
        let possibleRanges = this.locations
        .filter(location =>
          this.model.locations.some(modelLoc => modelLoc.id === location.id)
        )
        .flatMap(location =>
          (location.ranges || []).map(range => ({
            delivery_ranges_id: range.id,
            name: range.name,
            user_id: this.userId
          }))
        )
        // remove imposible ranges
        if (!Array.isArray(this.model.delivery_ranges)) {
          this.model.delivery_ranges = []
        }
        this.model.delivery_ranges = this.model.delivery_ranges.filter(range =>
          possibleRanges.some(possible => range.delivery_ranges_id === possible.delivery_ranges_id)
        )
        return possibleRanges
      },
      dispatcherMode () {
        return this.model.role === 'DISPATCHER'
      }
    },
    created () {
      this.userRole = this.$session.get('userDataRole')
      this.getData()
    },
    data () {
      return {
        userRole: null,
        roles: [],
        locations: [],
        zones: [],
        id: this.value || this.userId,
        isNew: true,
        filelist: [],
        model: {
          'lastname': '',
          'firstname': '',
          'password': '',
          'confirm_password': '',
          'role': '',
          'locations': '',
          'login_code': null,
          'active': true
        },
        fiscalPrinter: [],
        fromDispatchSettings: false,
        fromDispatcherSettings: false,
        fromKdsSettings: false,
        driver_schedule_active: 0,
        driverCode: '',
        is_manager: false,
        is_manager_first: true,
        dispatcherErrors: {
          firstname: false,
          lastname: false,
          email: false,
          login_code: false
        },
        modelValidate: {
          available_days: { required: true },
          firstname: {required: true, min: 3},
          lastname: {required: true, min: 3},
          email: {required: true},
          role: {required: true},
          password: {required: true},
          password_confirmation: {
            required: true
          },
          username: {required: true},
          language: {required: true},
          locations: {required: true}
        },
        allowedPermissions: [
          'can_access_supplier_orders',
          'can_create_supplier_order',
          'can_send_supplier_order',
          'can_receive_supplier_order',
          'can_validate_supplier_order',
          'can_generate_nir',
          'can_process_supplier_order',
          'can_generate_aviz',
          'can_generate_invoice',
          'can_access_dashboard',
          'can_access_gestiune',
          'can_access_reports',
          'can_access_settings'
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '24:00'
        },
        available_days: [
          this.$t('days.monday'),
          this.$t('days.tuesday'),
          this.$t('days.wednesday'),
          this.$t('days.thursday'),
          this.$t('days.friday'),
          this.$t('days.saturday'),
          this.$t('days.sunday')
        ],
        languages: this.$session.get('defaultData')['available_languages'],
        loading: true,
        loadingReset: true,
        loggedUserId: null
      }
    },
    methods: {
      checkQueryParams () {
        const query = (this.route && this.route.query) ? this.route.query : {}
        this.fromDispatchSettings = query.from === 'dispatchSettings'
        this.fromDispatcherSettings = query.from === 'dispatcherSettings'
        this.fromKdsSettings = query.from === 'kdsSettings'
      },
      ensurePriceListPermission (user) {
        if (!this.model.permissions_map) {
          this.$set(this.model, 'permissions_map', {})
        }
        if (typeof this.model.permissions_map.general_can_access_price_lists === 'undefined') {
          const fromField = !!(user && (user.is_allowed_to_see_price_lists === true || user.is_allowed_to_see_price_lists === 1 || user.is_allowed_to_see_price_lists === '1'))
          this.$set(this.model.permissions_map, 'general_can_access_price_lists', fromField)
        }
        this.syncPriceListWithCatalog()
      },
      syncPriceListWithCatalog () {
        if (!this.model.permissions_map) {
          return
        }
        if (!this.model.permissions_map.general_can_access_catalog) {
          this.$set(this.model.permissions_map, 'general_can_access_price_lists', false)
        }
      },
      onGeneralPermissionChange (key, value) {
        if (key === 'general_can_access_catalog' && !value) {
          this.syncPriceListWithCatalog()
        }
      },
      addMoreIntervals (index) {
        const newObj = {
          'day': index,
          'from': '',
          'to': ''
        }
        this.model.driver_schedule[index].push(newObj)
        // Vue.set(this.model.driver_schedule[index], index, newObj)
      },
      deleteIntervals (dayIdx, intervalKey) {
        this.model.driver_schedule[dayIdx].splice(intervalKey, 1)
      },
      getData () {
         // 1️⃣ Setează id-ul sigur
        let idFromRoute = (this.route && this.route.params) ? this.route.params.id : null
        this.id = this.userId || idFromRoute || null
        this.isNew = !this.id

        // Query flags before async role defaults
        this.checkQueryParams()

        // 2️⃣ Setează locațiile (cu zone pentru DRIVER)
        this.loading = true
        this.loadingReset = true

        var dataToBeSent = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-locations-and-zones', 'GET', dataToBeSent, (response) => {
          if (response.status === true) {
            this.locations = response.data.locations
          }
        })

        // 4️⃣ Validator localize
        this.$validator.localize(this.$i18n.locale || 'en', {
          [this.$i18n.locale || 'en']: {
            attributes: {
              firstname: this.$t('settingUsers.fn'),
              lastname: this.$t('settingUsers.ln'),
              email: this.$t('settingUsers.email'),
              login_code: this.$t('settingTable.login_code')
            },
            custom: {
              email: {
                required: this.$t('validations.requiredField'),
                email: this.$t('validations.requiredField')
              },
              login_code: {
                required: this.$t('validations.requiredField'),
                regex: this.$t('validations.requiredField')
              }
            }
          }
        })

        // 5️⃣ Logged user
        const userData = JSON.parse(this.$session.get('userData') || '{}')
        this.loggedUserId = userData.id || null

        // 6️⃣ Apel API listdefaults
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/listdefaults', 'GET', data, (response) => {
          if (response.status === true) {
            this.roles = response.data[0].user_roles || []

            if (this.fromDispatchSettings) this.model.role = 'DRIVER'
            if (this.fromDispatcherSettings) this.model.role = 'DISPATCHER'
            if (this.fromKdsSettings) this.model.role = 'KDS_OPERATOR'
          }
        })

        // 7️⃣ Apel API fiscal printer
        const dataFiscal = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/fiscal-printer', 'GET', dataFiscal, (response) => {
          if (response.status === true) {
            this.fiscalPrinter = response.data.fiscalPrinter || null
          }
        })

        // 8️⃣ Dacă nu e nou, preia profil
        if (!this.isNew) {
          const profileId = this.id
          this.apiRequest('/profile/' + profileId, 'GET', data, (response) => {
            if (response.status === true && response.data && response.data[0]) {
              const user = response.data[0]
              user.imagelist = user.avatar ? [{ url: user.avatar }] : []
              this.model = user
              this.model.locations = user.locations_formatted || []
              this.ensurePriceListPermission(user)
              if (this.model.role === 'DISPATCHER') {
                this.initDispatcherManagerFlags()
              }

              this.loading = false
              this.loadingReset = false
            }
          })
        } else {
          this.loading = false
          this.loadingReset = false
        }
      },
      // getData () {
      //   console.log('Created UserForm.vue', this.userId)
      //   var self = this
      //   this.locations = this.$session.get('selectedCompanyData').locations_details
      //   this.$nextTick(function () {
      //     this.loading = true
      //     this.loadingReset = true
      //   })
      //   this.$validator.localize('en', {
      //     en: {
      //       attributes: {
      //         firstname: this.$t('settingUsers.fn'),
      //         lastname: this.$t('settingUsers.ln')
      //       }
      //     }
      //   })
      //   this.loggedUserId = JSON.parse(this.$session.get('userData')).id
      //   var data = {
      //     token: this.$session.get('token'),
      //     company_id: this.$session.get('selectedCompany')
      //   }
      //   this.apiRequest('/listdefaults', 'GET', data, function (response) {
      //     if (response.status === true) {
      //       self.roles = response.data[0].user_roles

      //       // Setează rolul modelului dacă venim din sursa externa
      //       if (this.fromDispatchSettings) {
      //         this.model.role = 'DRIVER'
      //       }
      //       if (this.fromKdsSettings) {
      //         this.model.role = 'KDS_OPERATOR'
      //       }
      //     }
      //   })

      //   var dataFiscal = {
      //     token: this.$session.get('token'),
      //     company_id: this.$session.get('selectedCompany')
      //   }
      //   this.apiRequest('/fiscal-printer', 'GET', dataFiscal, response => {
      //     if (response.status === true) {
      //       this.fiscalPrinter = response.data.fiscalPrinter
      //     }
      //   })

      //   if ((this.route.params.id !== undefined && this.route.params.id) ||
      //     (this.id !== undefined && this.id !== null)) {
      //     this.isNew = false
      //   } else {
      //     this.isNew = true
      //   }
      //   if (!this.isNew) {
      //     var id = this.route.params.id || this.id
      //     this.apiRequest('/profile/' + id, 'GET', data, function (response) {
      //       if (response.status === true) {
      //         if (response.data[0].avatar) {
      //           response.data[0].imagelist = [{url: response.data[0].avatar}]
      //         } else {
      //           response.data[0].imagelist = []
      //         }
      //         self.model = response.data[0]
      //         self.model.locations = response.data[0].locations_formatted
      //         self.$nextTick(function () {
      //           self.loading = false
      //           self.loadingReset = false
      //         })
      //       }
      //     })
      //   } else {
      //     this.$nextTick(function () {
      //       this.loading = false
      //       this.loadingReset = false
      //     })
      //   }
      //   this.checkQueryParams()
      // },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      hasFieldError (field) {
        if (this.dispatcherMode) {
          return !!this.dispatcherErrors[field]
        }
        return this.errors.has(field)
      },
      onDispatcherFieldChange (field) {
        if (!this.dispatcherMode) return
        this.validateDispatcherField(field)
      },
      validateDispatcherField (field) {
        if (field === 'firstname') {
          this.dispatcherErrors.firstname = !(this.model.firstname || '').trim()
        } else if (field === 'lastname') {
          this.dispatcherErrors.lastname = !(this.model.lastname || '').trim()
        } else if (field === 'login_code') {
          const code = this.model.login_code == null ? '' : String(this.model.login_code).trim()
          this.dispatcherErrors.login_code = !/^[0-9]{4}$/.test(code)
        }
        return !this.dispatcherErrors[field]
      },
      checkDispatcherFields () {
        if (!this.dispatcherMode) return true
        this.validateDispatcherField('firstname')
        this.validateDispatcherField('lastname')
        this.validateDispatcherField('login_code')
        return !this.dispatcherErrors.firstname &&
          !this.dispatcherErrors.lastname &&
          !this.dispatcherErrors.login_code
      },
      validate () {
        this.errors['items'] = this.removeErrorByName('password_confirmation', this.errors['items'])
        if (this.dispatcherMode) {
          if (this.checkDispatcherFields()) {
            this.saveUser()
          }
          return
        }
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveUser() }
        })
      },
      validateReset () {
        if (this.model.password === undefined || this.model.password === '') {
          this.errors.add('password_2', this.$t('validations.passReq'))
        } else if (this.model.password.length < 6) {
          this.errors.add('password_2', this.$t('validations.passMin'))
        } else if (this.model.password_confirmation === undefined || this.model.password_confirmation === '') {
          this.errors.add('password_confirm_2', this.$t('validations.passReq'))
        } else if (this.model.password !== this.model.password_confirmation) {
          this.errors.add('password_confirm_2', this.$t('validations.passConf'))
        } else {
          this.resetPass()
        }
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      handleImgChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: 'Please remove the current file in order to be able to add a new one',
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      saveUser () {
        this.syncPriceListWithCatalog()
        this.$nextTick(function () { this.loading = true })
        let data = {}
        let locationsIDs = (Array.isArray(this.model.locations) && this.model.locations.length)
          ? this.model.locations.map(el => el.id)
          : []
        if (!this.isNew) {
          data = {
            id: this.model.id,
            firstname: this.model.firstname,
            lastname: this.model.lastname,
            email: this.model.email,
            phone: this.model.phone,
            driver_schedule_active: this.model.driver_schedule_active || 0,
            language: this.model.language,
            driver_schedule: this.model.driver_schedule,
            fiscal_printer_id: this.model.fiscal_printer_id,
            server_ip_port: this.model.server_ip_port,
            permissions_map: this.model.permissions_map,
            locations: locationsIDs
          }
          if (this.model.role !== 'OWNER') {
            data['role'] = this.model.role
          }
          if (this.model.role === 'DISPATCHER') {
            data.login_code = this.model.login_code
            data.active = this.model.active
            Object.assign(data, this.getDispatcherManagerPayload())
          }
        } else if (this.model.role === 'DISPATCHER') {
          // No email/password UI — server auto-generates both; login is login_code.
          const randomPass = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2) + 'Aa1!'
          data = {
            role: 'DISPATCHER',
            firstname: this.model.firstname,
            lastname: this.model.lastname,
            login_code: this.model.login_code,
            active: this.model.active !== false,
            locations: locationsIDs,
            password: randomPass,
            password_confirmation: randomPass,
            language: this.model.language || (this.$session.get('selectedCompanyData') || {}).language || 'en',
            ...this.getDispatcherManagerPayload()
          }
        } else {
          data = Object.assign({}, this.model)
        }
        var companyID = this.$session.get('selectedCompany')
        data.token = this.$session.get('token')
        data.company_id = companyID
        var self = this
        if (this.isNew) {
          delete data.avatar
          var postData = data
          postData.locations = locationsIDs
          // console.info('POST 1', postData, data)
          this.apiRequest('/profile', 'POST', postData, function (response) {
            if (response.status === true) {
              var id = response.data[0].id
              if (data.imagelist && data.imagelist.length && data.imagelist[0] && data.imagelist[0].status === 'ready') {
                self.getBase64(data.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.avatar = base64enc
                    data2.locations = postData.locations

                    // console.info('PUT 1')

                    self.apiRequest('/profile/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.errors.clear()
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('settingUsers.userAdded'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                        if (typeof self.callback === 'function') {
                          self.callback()
                        } else {
                          // self.$router.push('/user/edit/' + id)
                          self.$bus.$emit('refresh')
                          self.$bus.$emit('close-modal')
                        }
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('settingUsers.userPicError'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.$nextTick(function () { self.loading = false })
                self.errors.clear()
                swal(
                  {
                    title: '',
                    text: self.$t('settingUsers.userAdded'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                )
                .then(() => {})
                .catch(() => {})
                if (typeof self.callback === 'function') {
                  self.callback()
                } else {
                  // self.$router.push('/user/edit/' + id)
                  self.$bus.$emit('refresh')
                  self.$bus.$emit('close-modal')
                }
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
              let selectedLocations = []
              self.locations.forEach(function (el) {
                if (self.model.locations.includes(el.id)) {
                  selectedLocations.push({
                    id: el.id,
                    name: el.name
                  })
                }
              })
              self.model.locations = selectedLocations
              // console.info('prev sel locations ... ', selectedLocations)
            }
          })
        } else {
          var id = this.id || this.route.params.id

          if (data.role === 'OWNER') {
            delete data.role
          }

          delete data.avatar
          // check if the've removed the picture
          if (this.model.imagelist.length === 0) {
            data.avatar = ''
          }

          data.locations = self.model.locations.map(function (el) {
            return el.id
          })

          var user = JSON.parse(this.$session.get('userData'))
          if (id === user.id) {
            var url = '/profile/me'
          } else {
            url = '/profile/' + id
          }

          // console.info('PUT 2')

          this.apiRequest(url, 'PUT', data, function (response) {
            if (response.status === true) {
              if (id === user.id) {
                // console.warn(data.language)
                if (self.$i18n.locale !== data.language) {
                  self.$i18n.locale = data.language
                }
                self.$session.set('userData', JSON.stringify(response.data[0]))
              }
              if (self.model.imagelist.length && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.avatar = base64enc
                    data2.locations = data.locations

                    // console.info(data2)
                    // console.info('PUT 3')

                    self.apiRequest('/profile/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        var user = JSON.parse(self.$session.get('userData'))
                        if (id === user.id) {
                          self.$session.set('companyAvatar', data2.avatar)
                        }
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('settingUsers.userUpdated'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                        if (typeof self.callback === 'function') {
                          self.callback()
                        }
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('settingUsers.userPicError'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.$nextTick(function () { self.loading = false })
                swal(
                  {
                    title: '',
                    text: self.$t('settingUsers.userUpdated'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                )
                .then(() => {})
                .catch(() => {})
                if (typeof self.callback === 'function') {
                  self.callback()
                }
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          }) // end api response
        }
      },
      resetPass () {
        this.$nextTick(function () { this.loadingReset = true })
        var id = this.id || this.route.params.id
        let userLocations = this.model.locations.length ? this.model.locations.map(el => el.id) : []
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          password: this.model.password,
          password_confirmation: this.model.password_confirmation,
          locations: userLocations
        }
        // var self = this
        var self = this
        // console.info('PUT 4')
        this.apiRequest('/profile/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            self.$nextTick(function () { self.loadingReset = false })
            swal({'text': 'New password saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          } else {
            self.$nextTick(function () { self.loadingReset = false })
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      onDispatchRoleChange (role) {
        this.dispatcherErrors = {
          firstname: false,
          lastname: false,
          email: false,
          login_code: false
        }
        if (role === 'DRIVER') {
          this.getDriverCode(role)
        } else if (role === 'DISPATCHER') {
          this.model.email = ''
          this.model.active = true
        }
      },
      getDriverCode (role) {
        if (role === 'DRIVER') {
          this.model.driver_schedule_active = 1
          if (this.driverCode === '' || this.driverCode === null) {
            var id = this.$session.get('selectedCompany')
            var data = {
              company_id: id,
              token: this.$session.get('token')
            }
            var self = this

            this.apiRequest('/settings/newdriver/' + id, 'GET', data, function (response) {
              if (response.status === true) {
                self.driverCode = response.data['email']
                self.model.email = self.driverCode
              } else {
                swal({'text': response.error['email'] ? response.error['email'] : self.$t('validations.wentWrong'), 'type': 'error'}).catch({})
              }
            })
          } else {
            this.model.email = this.driverCode
          }
        } else {
          this.model.email = ''
        }
      },
      clearDispatchExcludedManagerFlags () {
        this.model.pos_allow_storno = false
        this.model.allow_access_all_tables = false
        this.model.pos_allow_transfer = false
        this.model.pos_allow_waiter_transfer = false
        this.model.pos_allow_table_transfer = false
      },
      getDispatcherManagerPayload () {
        this.clearDispatchExcludedManagerFlags()
        return {
          pos_allow_access_reports: !!this.model.pos_allow_access_reports,
          pos_allow_reports: !!this.model.pos_allow_reports,
          pos_allow_approvals: !!this.model.pos_allow_approvals,
          pos_allow_discount: !!this.model.pos_allow_discount,
          pos_allow_refund: !!this.model.pos_allow_refund,
          pos_allow_storno: false,
          allow_access_all_tables: false,
          pos_allow_transfer: false,
          pos_allow_waiter_transfer: false,
          pos_allow_table_transfer: false
        }
      },
      initDispatcherManagerFlags () {
        this.clearDispatchExcludedManagerFlags()
        const hasManagerFlags =
          this.model.pos_allow_access_reports ||
          this.model.pos_allow_reports ||
          this.model.pos_allow_approvals ||
          this.model.pos_allow_discount ||
          this.model.pos_allow_refund
        if (hasManagerFlags) {
          this.is_manager_first = false
          this.is_manager = true
        } else {
          this.is_manager = false
          this.is_manager_first = true
        }
      },
      onChangeManager () {
        if (!this.dispatcherMode) {
          return
        }
        if (this.is_manager_first) {
          if (this.is_manager) {
            this.model.pos_allow_discount = true
            this.model.pos_allow_refund = true
            this.model.pos_allow_reports = true
            this.model.pos_allow_access_reports = true
            this.model.pos_allow_approvals = true
            this.clearDispatchExcludedManagerFlags()
          } else {
            this.model.pos_allow_discount = false
            this.model.pos_allow_refund = false
            this.model.pos_allow_reports = false
            this.model.pos_allow_access_reports = false
            this.model.pos_allow_approvals = false
            this.clearDispatchExcludedManagerFlags()
          }
        }
        this.is_manager_first = true
      },
      cancelUser () {
        if (typeof this.callback === 'function') {
          this.callback()
        } else if (this.fromDispatchSettings) {
          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
          // this.router.push({ path: '/dispatch', query: { tabIndex: 4 } })
        } else if (this.fromKdsSettings) {
          // this.router.push({ path: '/screens/kds', query: { tabIndex: 2 } })
          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
        } else {
          // this.router.go(-1)
          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
        }
      }
    }
  }
</script>
<style>
  .interval {
    width: 100%;
    display: flex;
    flex-direction: column;
    /* background: #eee;
    border-bottom: 1px solid #000; */
    padding: 10px;
  }
  .upload-demo input[type="file"]{ display: none; }
  .el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--time-select {
    width: 150px !important;
  }
  .isManagerBox {
    margin-bottom: 20px;
  }
  .isManagerBox .managerBox {
    padding: 20px;
    border: 1px solid #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Users/UserForm.vue